import {AxiosResponse } from 'axios';

import apiClient from '../client';
import { PageResultDto } from 'interfaces/page';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { CreateScheduleDto, ScheduleDto } from 'interfaces/schedules/schedule';

interface EmployeeScheduleService {
  search(employeeId: string, queryParams?: any): Promise<PageResultDto<ScheduleDto>>
  get(employeeId: string, id: string): Promise<ScheduleDto>
  create(employeeId: string, postData: CreateScheduleDto): Promise<ScheduleDto>
  update(employeeId: string, id: string, postData: CreateScheduleDto): Promise<ScheduleDto>
  delete(employeeId: string, id: string): Promise<void>
}

const endpoints = {
  search: (employeeId: string) => `/employees/${employeeId}/schedules`,
  get: (employeeId: string, id: string) => `/employees/${employeeId}/schedules/${id}`,
  create: (employeeId: string) => `/employees/${employeeId}/schedules`,
  edit: (employeeId: string, id: string) => `/employees/${employeeId}/schedules/${id}`,
  delete: (employeeId: string, id: string) => `/employees/${employeeId}/schedules/${id}`,
}

export const employeeScheduleService: EmployeeScheduleService = {
  search: async (employeeId: string, queryParams?: any): Promise<PageResultDto<ScheduleDto>> => {
    const response: AxiosResponse<ApiResponseDto<PageResultDto<ScheduleDto>>> =
      await apiClient.get(
        endpoints.search(employeeId),
        {params: {...queryParams}, paramsSerializer: {indexes: null}}
      );

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  get: async (employeeId: string, id: string): Promise<ScheduleDto> => {
    const response: AxiosResponse<ApiResponseDto<ScheduleDto>> = await apiClient.get(
      endpoints.get(employeeId, id)
    );

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  create: async (employeeId: string, postData: CreateScheduleDto): Promise<ScheduleDto> => {
    const response: AxiosResponse<ApiResponseDto<ScheduleDto>> = await apiClient.post(endpoints.create(employeeId), postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  update: async (employeeId: string, id: string, postData: CreateScheduleDto): Promise<ScheduleDto> => {
    const response: AxiosResponse<ApiResponseDto<ScheduleDto>> =
      await apiClient.put(endpoints.edit(employeeId, id), postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  delete: async (employeeId: string, id: string): Promise<void> => {
    const response: AxiosResponse<ApiResponseDto<void>> = await apiClient.delete(endpoints.delete(employeeId, id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }
  },
}
